// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-confirm-box {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  font-family: "Segoe UI", sans-serif;
}

.custom-confirm-box h3 {
  margin-bottom: 1rem;
  color: #333;
}

.details p {
  margin: 0.3rem 0;
  font-size: 0.95rem;
  color: #555;
}

.btn-group {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.approve-btn,
.reject-btn {
  padding: 0.5rem 1.2rem;
  font-size: 0.9rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
}

.approve-btn {
  background-color: #28a745;
  color: white;
}

.reject-btn {
  background-color: #dc3545;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/Components/settings/Company/RegisterCompany/CustomDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".custom-confirm-box {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 450px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n.custom-confirm-box h3 {\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.details p {\n  margin: 0.3rem 0;\n  font-size: 0.95rem;\n  color: #555;\n}\n\n.btn-group {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n\n.approve-btn,\n.reject-btn {\n  padding: 0.5rem 1.2rem;\n  font-size: 0.9rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.approve-btn {\n  background-color: #28a745;\n  color: white;\n}\n\n.reject-btn {\n  background-color: #dc3545;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
